import styled, { css } from 'styled-components';
import { themeProvider } from '@swipejobs/frontend-theme-provider';

const flexRow = css`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const flexColumn = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const DetailsContainer = styled.div<{ useSeparator?: boolean }>`
  ${flexRow};
  border: ${() => themeProvider.getFraming().border.tiny};
  border-bottom: ${props => props.useSeparator ?
    () => themeProvider.getFraming().border.mediumPlus :
    () => themeProvider.getFraming().border.tiny};
  border-color: #cccccc;
  border-right: 0;
`;

export const DetailsColumnContainer = styled.div<{ flex?: number }>`
  ${flexColumn};
  width: 100%;
  font-size: 15px;
  flex: ${props => props.flex ? `0 ${props.flex}px` : 1};
  border-right: ${() => themeProvider.getFraming().border.tiny};
  border-color: #cccccc;
  
  & div:nth-child(odd) {
    background-color: #F6F7F9;
  }
`;

export const DetailsCell = styled.div`
  ${flexColumn};
  box-sizing: content-box;
  border: 0;
  padding: 10px;
  flex: 0 38px;
`;

export const Step4Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  font-family: ${() => themeProvider.getTypography().font.family.handwriting};
  background-color: ${() => themeProvider.getColors().background.grayBackgroundColor};
  border: ${() => themeProvider.getFraming().border.tiny};
  padding: 5px;
`;

export const Step4Title = styled.div`
    font-size: ${() => themeProvider.getTypography().font.size.larger};
    font-weight: bold;
    padding-right: 10px;
    box-sizing: border-box;
`;

export const Step4SubTitle = styled.div`
    font-style: italic;
    font-size: ${() => themeProvider.getTypography().font.size.large};
`;

export const ColumnDiv = styled.div<{proportion?: number, topSpacing?: boolean}>`
  ${flexColumn};
  flex: ${props => props.proportion ? `1 ${props.proportion}%` : 1};
  width: 100%;
  min-width: 230px;
  margin-top: ${props => props.topSpacing ? '10px' : '0'};
`;

export const FlexWrapContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  background-color: ${() => themeProvider.getColors().background.secondaryBackgroundColor};
  border: ${() => themeProvider.getFraming().border.tiny};
  padding: 5px;
  box-sizing: border-box;
`;

export const FieldLabel = styled.div`
  padding: 4px 15px;
  font-size: ${() => themeProvider.getTypography().font.size.normal};
  white-space: nowrap;
`;

export const FieldCell = styled.div<{maxSize?: number}>`
  ${flexColumn};
  border: ${() => themeProvider.getFraming().border.tiny};
  max-width: ${props => props.maxSize ? `${props.maxSize}px` : null};
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/details-styles.tsx